import React from 'react';
import { useParams } from 'react-router-dom';
import { RiRobot2Fill as RobotIcon } from 'react-icons/ri';
import { IoMdCloudUpload as UploadIcon } from 'react-icons/io';
import { FaPaintBrush as PaintIcon } from 'react-icons/fa';
import { MdIntegrationInstructions as EmbedIcon } from 'react-icons/md';
import { IoTimer as ConversationIcon } from 'react-icons/io5';
import { IoChatbubbleEllipses as ChatIcon } from 'react-icons/io5';

const allMenuItems = [
  { href: '#configuraProgetto', icon: <RobotIcon />, label: 'Configura' },
  { href: '#aspettoChat', icon: <PaintIcon />, label: 'Aspetto' },
  { href: '#caricaDocumenti', icon: <UploadIcon />, label: 'Contenuti' },
  { href: '#includiInProgetto', icon: <EmbedIcon />, label: 'Integrazione' },
  {
    href: '#storicoConversazioni',
    icon: <ConversationIcon />,
    label: 'Conversazioni',
  },
];

const ProjectMenu = ({
  setNavbarGeneralChange,
  dettagliProgetto,
  navbarGeneralChange,
}) => {
  console.log(dettagliProgetto?.[0]?.type);
  const { id } = useParams();

  const type = dettagliProgetto?.[0]?.type;

  // Per phone-agent nascondiamo Aspetto e Integrazione
  const excludedMenuForPhoneAgent = ['#aspettoChat', '#includiInProgetto'];

  // Filtra i menu in base al tipo progetto
  const menuItems =
    type === 'phone-agent'
      ? allMenuItems.filter(
          (item) => !excludedMenuForPhoneAgent.includes(item.href)
        )
      : allMenuItems;

  const handleNavClick = (href) => {
    // Se phone-agent e href non consentito, forziamo #configuraProgetto
    if (type === 'phone-agent' && excludedMenuForPhoneAgent.includes(href)) {
      setNavbarGeneralChange('#configuraProgetto');
    } else {
      setNavbarGeneralChange(href);
    }
  };

  const renderButton = () => {
    if (type === 'phone-agent') return null; // Non mostrare il bottone di prova chat

    let href = '#qaAssistant';
    if (type === 'mysql-agent') href = '#agenteSQL';
    else if (type === 'conversational') href = '#conversationalAssistant';

    return (
      <a
        href={href}
        className="btn bg-orange text-white fw-bold font-size-20 h-100 w-100 d-flex align-items-center justify-content-center"
        onClick={() => handleNavClick(href)}
      >
        <ChatIcon />
      </a>
    );
  };

  return (
    <nav>
      <div className="row">
        <div
          className={`col-11 d-flex justify-content-between bg-dark ${
            type === 'phone-agent' ? 'col-12' : 'col-11'
          }`}
          style={{ borderRadius: '10px' }}
        >
          {menuItems.map((item) => (
            <div
              key={item.href}
              className="col-auto d-flex align-items-center justify-content-between px-3"
              style={{ height: '60px' }}
            >
              <div
                className={`navbar-project-menu-item ${
                  navbarGeneralChange === item.href ? 'active-item' : ''
                }`}
              >
                <a
                  href={item.href}
                  className="nav-link fw-bold text-capitalize p-0"
                  onClick={() => handleNavClick(item.href)}
                >
                  {item.icon} {item.label}
                </a>
              </div>
            </div>
          ))}
        </div>
        <div className="col-1">
          <div className="d-flex align-items-center justify-content-end h-100">
            {renderButton()}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default ProjectMenu;
